
import {initWebComponent} from "@/helpers/web-component-helper";
import {generateGeoJsonObjectFromFeature} from "@/helpers/ol/ol-geo-json-helper.js";
import {getArea, getLength} from "ol/sphere.js";
import {WKT} from "ol/format.js";
import {escapeOutput} from "@/helpers/output-helper.js";

export class LayerInfoInfoTypeComponent extends HTMLElement {
    constructor(){
        super();

        const key = this.getAttribute('data-key')
        const childKey = this.getAttribute('data-child-key')
        const mainTabIndex = this.getAttribute('data-main-tab-index')
        const featureInfoKey = this.getAttribute('data-feature-info-key')
        const featureKey = this.getAttribute('data-feature-key')
        const recordIndex = this.getAttribute('data-record-index')
        const isTable = this.getAttribute('data-is-table')

        const featureInfo = window.attributeItems[featureKey][featureInfoKey].featureInfo

        let attributeItem
        if(recordIndex === null) {
            attributeItem = window.attributeItems[featureKey][featureInfoKey].attributeItems[key]
        } else {
            if( window.attributeItems[featureKey][featureInfoKey].records[recordIndex]) {
                if(childKey) {
                    attributeItem = window.attributeItems[featureKey][featureInfoKey].records[recordIndex].attributeItems[key][childKey]
                } else {
                    attributeItem = window.attributeItems[featureKey][featureInfoKey].records[recordIndex].attributeItems[key]
                }
            }
        }

        if(!attributeItem || (Array.isArray(attributeItem) && attributeItem[0] === undefined)) {
            return
        }

        const template = document.createElement('template');
        let innerHTML = ``

        // Skip geometrie
        if(attributeItem.Type === 21) {

            if(featureInfo.records[0].attributes.length > 1) {
                return
            }

            const geoJson = generateGeoJsonObjectFromFeature(window.attributeItems[featureKey][featureInfoKey].featureInfo.records[recordIndex], false)
            const olFeature = geoJson[0]
            const olGeometry = olFeature.getGeometry()
            const format = new WKT()
            const wkt = format.writeGeometry(olGeometry);

            innerHTML = `
            <div class="row">
                <div class="col-5">Oppervlakte</div>
                <div class="col-7">${olGeometry.getArea().toFixed(2)} m2</div>
            </div>
            <div class="row">
                <div class="col-5">Omtrek</div>
                <div class="col-7">${getLength(olGeometry).toFixed(2)} m</div>
            </div>
            <div class="row">
                <div class="col-5">WKT</div>
                <div class="col-7">
                    <input readonly title="${wkt}" type="text" value="${wkt}" class="form-control">
                </div>
            </div>
            `
        } else {


            let displayName = attributeItem.DisplayName
            if (attributeItem && Array.isArray(attributeItem) && attributeItem[0]) {
                displayName = attributeItem[0].DisplayName
            }

            if (isTable !== 'true') {
                if (featureInfo.FormType === 1) {
                    innerHTML += `<div class="row">
                    <div class="col-5">${displayName}</div>
                    <div class="col-7">`

                    // Embed URL
                    if (attributeItem.Type === 3 && attributeItem.Action === 2) {
                        innerHTML = `<div class="row">
                    <div class="col-12">`
                    }

                } else {
                    innerHTML += `
                <div class="form-group mb-2">
                    <h4 class="mb-0">${displayName}</h4>`
                }
            }

            if (attributeItem && Array.isArray(attributeItem)) {
                attributeItem.map((attribute, index) => {
                    innerHTML += generateHtml(attribute, index)
                })
            } else {
                innerHTML += generateHtml(attributeItem)
            }

            if (isTable !== 'true') {
                if (featureInfo.FormType === 1) {
                    innerHTML +=
                        `</div>
                </div>
                `;
                } else {
                    innerHTML +=
                        `</div>
                `;
                }
            }
        }

        template.innerHTML = innerHTML

        initWebComponent(this, template)

        function generateHtml(attributeItem, index = '') {
            let innerHTML = ''
            switch (attributeItem.Type) {
                case 1:
                    innerHTML += `<layer-info-info-type-file data-feature-key="${featureKey}" data-record-index="` + recordIndex + `"  data-main-tab-index="` + mainTabIndex + `" data-feature-info-key="` + featureInfoKey + `" data-key="` + key + `" data-child-key="${childKey}"></layer-info-info-type-file>`
                    break;
                case 3:
                    innerHTML += `<layer-info-info-type-url data-feature-key="${featureKey}" data-record-index="` + recordIndex + `"  data-feature-info-key="` + featureInfoKey + `" data-key="` + key + `" data-child-key="${childKey}"></layer-info-info-type-url>`
                    break;
                case 402:
                case 403:
                    innerHTML += `<layer-info-info-type-date data-feature-key="${featureKey}" data-record-index="` + recordIndex + `" data-feature-info-key="` + featureInfoKey + `" data-key="` + key + `" data-child-key="${childKey}"></layer-info-info-type-date>`
                    break;
                case 404:
                    innerHTML += `<layer-info-info-type-text data-feature-key="${featureKey}" data-record-index="` + recordIndex + `" data-feature-info-key="` + featureInfoKey + `" data-attribute-index="${index}" data-key="` + key + `" data-child-key="${childKey}"></layer-info-info-type-text>`
                    break;
                default:
                    innerHTML += `<layer-info-info-type-text data-value="${escapeOutput(attributeItem.Value)}" data-feature-key="${featureKey}" data-record-index="` + recordIndex + `" data-feature-info-key="` + featureInfoKey + `" data-attribute-index="${index}" data-key="` + key + `" data-child-key="${childKey}"></layer-info-info-type-text>`
                    break;
            }
            return innerHTML
        }
    }
}

